
import AppSaleVatRegimeSelect from "@/components/common/SaleVatRegimeSelect.vue";
import AppPurchaseVatRegimeSelect from "@/components/common/PurchaseVatRegimeSelect.vue";
import Vue from "vue";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		},
		label: {
			type: [String, Object as ()=>TranslateResult]
		},
		fancy: Boolean
	},
	methods: {
		async onInput(vatRegime: number) {
			this.state.onVatRegimeChange(vatRegime);
		}
	},
	components: {
		AppSaleVatRegimeSelect,
		AppPurchaseVatRegimeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
